"use client"

import { getPageTypeNameFromPath } from "@/lib/menu"
import { useEffect } from "react"
import { usePathname } from "next/navigation"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  const pathname = usePathname()
  const pageTypeName = getPageTypeNameFromPath(pathname || "")

  useEffect(() => {
    // Optionally log error to an error reporting service
    // console.error(error)
  }, [error])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--color-surface)] text-center px-4 py-12">
      <div className="w-full max-w-2xl bg-[var(--color-surface-secondary)] rounded-2xl shadow-lg p-8">
        <h1 className="text-2xl md:text-3xl font-bold mb-2 text-[var(--color-error)]">
          Oops! Something went wrong
        </h1>
        <p className="mb-4 text-lg text-[var(--text-color-default)]">
          Sorry, we couldn't load this{" "}
          <span className="font-semibold">{pageTypeName}</span> at{" "}
          <span className="text-[var(--color-primary)]">{pathname}</span>.
        </p>
        <p className="mb-6 text-[var(--text-color-secondary)]">
          <span
            role="img"
            aria-label="bug"
          >
            🐞
          </span>{" "}
          Looks like agnos.ai left a bug in the site.
          <br />
          We promise our AI is better at knowledge graphs than at web
          development!
        </p>
        {error?.message && (
          <details className="mb-6 text-left">
            <summary className="cursor-pointer font-semibold text-[var(--color-primary)] mb-2">
              Show technical error details
            </summary>
            <pre className="overflow-auto max-h-64 bg-[var(--color-surface)] border border-[var(--color-error)] rounded p-4 text-xs text-[var(--color-error)] whitespace-pre-wrap">
              {error.stack || error.message}
            </pre>
          </details>
        )}
        <button
          className="mt-2 px-6 py-2 rounded-full bg-[var(--color-primary)] text-white font-semibold hover:bg-[var(--color-primary-hover)] transition"
          onClick={() => reset()}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
